import React, { Fragment } from 'react'
import { FormSubmit, FormWrapper } from '@myxplor/forms'
import { errorHandler } from '../../io/error-handling'
import RemoteRequest from '../../remote-request'
import { ProviderLevelReportDone } from './views/done'
import { ReportDefaultSuccessMessage } from './views/default-success'

const defaultOnSubmit = ({ remote_request, url }) => payload =>
  remote_request.submit(url, {
    method: 'POST',
    jsonAPI: true,
    body: payload,
  })

export const ProviderLevelReportContainer = ({
  url,
  formOptions = {},
  name = 'Report',
  scoped = false,
  fieldsComponent,
  successComponent = ReportDefaultSuccessMessage,
  resetCurrentReport,
  remote_request,
  onSubmit = defaultOnSubmit,
}) => {
  const { loading, success } = remote_request.state

  if (success) {
    return (
      <ProviderLevelReportDone resetCurrentReport={resetCurrentReport}>
        {React.createElement(successComponent, {
          ...remote_request.state,
          name,
        })}
      </ProviderLevelReportDone>
    )
  }

  const errors = errorHandler(remote_request.state)

  return (
    <FormWrapper
      {...formOptions}
      onSubmit={onSubmit({ remote_request, url, name })}
      render={formProps => (
        <Fragment>
          {fieldsComponent && (
            <div className="reportForm--fields">
              {React.createElement(fieldsComponent, {
                ...formProps,
                loading,
                errors,
                scoped,
              })}
            </div>
          )}

          <FormSubmit
            loading={loading}
            errors={errors.summary || errors.detail}
            disabled={!formProps.valid}
            loadingTitle={`Generating ${name}...`}>
            {`Generate ${name}`}
          </FormSubmit>
        </Fragment>
      )}
    />
  )
}

export default RemoteRequest(ProviderLevelReportContainer)



// WEBPACK FOOTER //
// ./src/provider-level/reports/container.js